export default "__VITE_ASSET__DXuq2akw__"